import InfoIcon from '@mui/icons-material/Info';
import { Button } from '@tis/shared-tis-ui';
import React from 'react';
import CustomDialog from './CustomDialog';

interface SessionExpiredDialogProps {
  open: boolean;
  onLogin: () => void;
}

const SessionExpiredDialog: React.FC<SessionExpiredDialogProps> = ({
  open,
  onLogin,
}) => {
  if (!open) return null;

  return (
    <CustomDialog
      title="Session Expired"
      icon={<InfoIcon sx={{ color: '#215968' }} />}
      disableForceClose
      buttons={
        <Button color="primary" onClick={onLogin}>
          Login Again
        </Button>
      }
    >
      <p>Your session has expired. Please log in again to continue.</p>
    </CustomDialog>
  );
};

export default SessionExpiredDialog;
